import React from 'react';
import { Box, SimpleGrid, Image, Flex } from '@chakra-ui/react';
import Heading from '#coreComponents/Heading';

import australianNationalUniLogo from '../images/australian_national_uni_logo.png';
import durhamUniLogo from '../images/durham_uni_logo.png';
import emoryUnivLogo from '../images/emory-univ.png';
import glasgowLogo from '../images/glasgow_logo.png';
import groningenLogo from '../images/groningen_logo-en.png';
import johnsHopkinsLogo from '../images/johns_hopkins_logo.png';
import lmuMuenchenL from '../images/lmu_muenchen_logo.svg_.png';
import lomonosovLogo from '../images/lomonosovlogo.png';
import mitLogo from '../images/mit_logo_0.png';
import nusLogo from '../images/nus_logo.png';
import seolNationalUniLogo from '../images/seol_national_uni_logo.png';
import trinityCollegeDublinLogo from '../images/trinity-college-dublin-446-logo.png';
import hongKongPolyLogo from '../images/hk_poly_u_logo.png';
import ubcLogo from '../images/ubc-logo.png';
import uhkLogo from '../images/uhk_logo.png';
import universityOfMelbourneLogo from '../images/university_of_melbourne_australia.png';
import universityOfTokyoLogo from '../images/university-of-tokyo_logo1.png';
import universityOfTorontoLogo from '../images/university-of-toronto.png';
import uoaLogo from '../images/uoalogohb.png';
import uniOfHelsinkiLogo from '../images/uofhelsinki_logo.png';
import usydLogo from '../images/usyd_new_logo.png';
import washingtonStLouisLogo from '../images/washington_st_louis_logo.png';
import witsLogo from '../images/wits-logo.png';
import zhejiangUniversityLogo from '../images/zhejiang_university_logo.svg_.png';
import hongKongUniversityOfScienceTechnologyLogo from '../images/hong_kong_university_of_science_technology_0.png';
import monterreyInstituteOfTechnologyAndHigherEducationLogo from '../images/monterrey-institute-of-technology-and-higher-educa_0.jpg';
import nanyangTechnologicalUniversityLogo from '../images/nanyang_technological_university.jpg';

const customerLogos = [
  australianNationalUniLogo,
  durhamUniLogo,
  emoryUnivLogo,
  glasgowLogo,
  groningenLogo,
  johnsHopkinsLogo,
  lmuMuenchenL,
  lomonosovLogo,
  mitLogo,
  nusLogo,
  seolNationalUniLogo,
  trinityCollegeDublinLogo,
  hongKongPolyLogo,
  ubcLogo,
  uhkLogo,
  universityOfMelbourneLogo,
  universityOfTokyoLogo,
  universityOfTorontoLogo,
  uoaLogo,
  uniOfHelsinkiLogo,
  usydLogo,
  washingtonStLouisLogo,
  witsLogo,
  zhejiangUniversityLogo,
  hongKongUniversityOfScienceTechnologyLogo,
  monterreyInstituteOfTechnologyAndHigherEducationLogo,
  nanyangTechnologicalUniversityLogo,
];

const HomeCustomers = () => (
  <Box>
    <Heading as="h1" my={6} textAlign="center">
      Our customers include:
    </Heading>
    <SimpleGrid columns={[3, 4, 5, 6, 7]} spacing={4}>
      {customerLogos.map((logo) => (
        <Flex
          key={logo}
          flexDir="column"
          justifyContent="center"
          background="white"
          borderColor="gray.200"
          borderStyle="solid"
          borderRadius={2}
          borderWidth={1}
          p={3}
        >
          <Image src={logo} />
        </Flex>
      ))}
    </SimpleGrid>
  </Box>
);

export default HomeCustomers;
